
const ProductPackageIdForQms = {
    key: "product Id",
    value: [
        {
            Id: "All",
            value: "All",
            isSelected: true
        },
        {
            Id: "400121",
            value: "simply protect",
            isSelected: false
        },
        {
            Id: "400351",
            value: "active income plan",
            isSelected: false
        },
        {
            Id: "400352",
            value: "three generation plan active income plan",
            isSelected: false
        },
        {
            Id: "400355",
            value: "active income plan with fib",
            isSelected: false
        },
        {
            Id: "400353",
            value: "whole life active income active income plan",
            isSelected: false
        },
        {
            Id: "400354",
            value: "retire befiker active income plan",
            isSelected: false
        },
        {
            Id: "400731",
            value: "wealth ultima",
            isSelected: false
        },
        {
            Id: "400732",
            value: "systematic withdrawal plan wealth ultima",
            isSelected: false
        },
        {
            Id: "400093",
            value: "little champ wealth ultima",
            isSelected: false
        },
        {
            Id: "400051",
            value: "smart lifestyle",
            isSelected: false
        },
        {
            Id: "400052",
            value: "family protection option smart lifestyle",
            isSelected: false
        },
        {
            Id: "400071",
            value: "gcap",
            isSelected: false
        },
        {
            Id: "400041",
            value: "cash flow protection plus",
            isSelected: false
        },
        {
            Id: "400301",
            value: "wealth gain plus",
            isSelected: false
        },
        {
            Id: "400311",
            value: "wealth secure plus",
            isSelected: false
        },
        {
            Id: "400313",
            value: "child variant wealth secure plus",
            isSelected: false
        },
        {
            Id: "400312",
            value: "systematic withdrawal plan wealth secure plus",
            isSelected: false
        },
        {
            Id: "400151",
            value: "dhan labh",
            isSelected: false
        },
        {
            Id: "400231",
            value: "wealth plus",
            isSelected: false
        },
        {
            Id: "400232",
            value: "rising star wealth plus",
            isSelected: false
        },
        {
            Id: "400601",
            value: "income builder",
            isSelected: false
        },
        {
            Id: "400602",
            value: "secured income option income builder",
            isSelected: false
        },
        {
            Id: "400321",
            value: "easy pension",
            isSelected: false
        },
        {
            Id: "400191",
            value: "single pay endowment assuarance plan",
            isSelected: false
        },
        {
            Id: "400591",
            value: "pos saral nivesh",
            isSelected: false
        },
        {
            Id: "400341",
            value: "wealth premier",
            isSelected: false
        },
        {
            Id: "400391",
            value: "saral jeevan bima",
            isSelected: false
        },
        {
            Id: "400392",
            value: "pos saral jeevan bima",
            isSelected: false
        },
        {
            Id: "400411",
            value: "saral pension",
            isSelected: false
        },
        {
            Id: "400403",
            value: "pos forever pension",
            isSelected: false
        },
        {
            Id: "400402",
            value: "forever pension deferred annuity",
            isSelected: false
        },
        {
            Id: "400401",
            value: "forever pension immediate annuity",
            isSelected: false
        },
        {
            Id: "400612",
            value: "premier guaranteed short term income",
            isSelected: false
        },
        {
            Id: "400613",
            value: "premier guaranteed long term income",
            isSelected: false
        },
        {
            Id: "400611",
            value: "premier guaranteed income lumpsum",
            isSelected: false
        },
        {
            Id: "400614",
            value: "premier guaranteed retirement income",
            isSelected: false
        },
        {
            Id: "400615",
            value: "premier guaranteed income lumpsum fib",
            isSelected: false
        },
        {
            Id: "400616",
            value: "premier guaranteed short term income fib",
            isSelected: false
        },
        {
            Id: "400617",
            value: "premier guaranteed long term income fib",
            isSelected: false
        },
        {
            Id: "400621",
            value: "guaranteed income star milestones guaranteed",
            isSelected: false
        },
        {
            Id: "400622",
            value: "guaranteed income star cashback guaranteed",
            isSelected: false
        },
        {
            Id: "400623",
            value: "guaranteed income star better innings",
            isSelected: false
        },
        {
            Id: "400624",
            value: "guaranteed income star",
            isSelected: false
        },
        {
            Id: "400625",
            value: "guaranteed income star cashback guaranteed fib",
            isSelected: false
        },
        {
            Id: "400626",
            value: "guaranteed income star better innings fib",
            isSelected: false
        },
        {
            Id: "400627",
            value: "guaranteed income star fib",
            isSelected: false
        },
        {
            Id: "400628",
            value: "pos guaranteed income star",
            isSelected: false
        },
        {
            Id: "400629",
            value: "pos guaranteed income star cashback guaranteed",
            isSelected: false
        },
        {
            Id: "4006210",
            value: "pos guaranteed income star better innings",
            isSelected: false
        },
        {
            Id: "400631",
            value: "guaranteed savings star lumpsum",
            isSelected: false
        },
        {
            Id: "400632",
            value: "guaranteed savings star income",
            isSelected: false
        },
        {
            Id: "400633",
            value: "guaranteed savings star lumpsum fib",
            isSelected: false
        },
        {
            Id: "400634",
            value: "guaranteed savings star income fib",
            isSelected: false
        },
        {
            Id: "400635",
            value: "guaranteed savings star",
            isSelected: false
        },
        {
            Id: "400641",
            value: "flexi savings plan child systematic withdrawal",
            isSelected: false
        },
        {
            Id: "400642",
            value: "flexi savings plan child age based withdrawal",
            isSelected: false
        },
        {
            Id: "400643",
            value: "flexi savings plan child age plus income based withdrawal",
            isSelected: false
        },
        {
            Id: "400644",
            value: "flexi savings plan child flexi income",
            isSelected: false
        },
        {
            Id: "400645",
            value: "flexi savings plan child flexi income pro",
            isSelected: false
        },
        {
            Id: "400646",
            value: "flexi savings plan child large sum option",
            isSelected: false
        },
        // {
        //     Id: "400647",
        //     value: "flexi savings plan systematic withdrawal",
        //     isSelected: false
        // },
        // {
        //     Id: "400648",
        //     value: "flexi savings plan age based withdrawal",
        //     isSelected: false
        // },
        // {
        //     Id: "400649",
        //     value: "flexi savings plan age plus income based withdrawal",
        //     isSelected: false
        // },
        {
            Id: "4006410",
            value: "flexi savings plan flexi income",
            isSelected: false
        },
        {
            Id: "4006411",
            value: "flexi savings plan flexi income pro",
            isSelected: false
        },
        {
            Id: "4006412",
            value: "flexi savings plan large sum option",
            isSelected: false
        },
        {
            Id: "400691",
            value: "zindagi protect",
            isSelected: false
        },
        {
            Id: "400661",
            value: "bharat savings star income",
            isSelected: false
        },
        // {
        //     Id: "400662",
        //     value: "bharat savings star lumpsum",
        //     isSelected: false
        // },
        {
            Id: "400663",
            value: "pos bharat savings star income",
            isSelected: false
        },
        // {
        //     Id: "400664",
        //     value: "pos bharat savings star lumpsum",
        //     isSelected: false
        // },
        {
            Id: "400681",
            value: "legacy plus",
            isSelected: false
        },
        {
            Id: "400682",
            value: "legacy plus lumpsum",
            isSelected: false
        },
        {
            Id: "400721",
            value: "Premier Guaranteed STAR",
            isSelected: false
        },
        {
            Id: "400741",
            value: "Active Pension Plus Advantage",
            isSelected: false
        },
        {
            Id: "400751",
            value: "Flexi Dream Plan",
            isSelected: false
        },
        {
            Id: "400771",
            value: "Assured Income Star",
            isSelected: false
        },
        {
            Id: "400781",
            value: "Flexi Goal Secure",
            isSelected: false
        },
    ]
}
export default ProductPackageIdForQms;
